<fullscreen-page class="np-detail-layout">
  <div class="np-detail-left">
    <div class="np-detail-header">
      <div class="np-detail-title-row">
        <dx-button
          class="np-detail-back-btn"
          icon="chevronleft"
          stylingMode="text"
          (onClick)="goBackToPrepareStage()"
        ></dx-button>

        <div class="np-detail-title text-truncate">
          {{ catalogTitle }}
        </div>
      </div>

      <dx-tab-panel
        class="prepare-tabs"
        [dataSource]="tabItems"
        [selectedIndex]="selectedTabIndex"
        [animationEnabled]="true"
        [swipeEnabled]="false"
        [deferRendering]="false"
        (onSelectionChanged)="onTabSelectionChanged($event)"
      >
        <div *dxTemplate="let tab of 'title'">
          <span class="text-truncate">{{ tab.title }}</span>
        </div>

        <div *dxTemplate="let tab of 'item'"></div>
      </dx-tab-panel>
    </div>

    <div class="np-detail-body">
      <catalog
        class="np-detail-browse d-block h-100"
        [routeBasePath]="'/dataprocess/preparation/catalog'"
        [customerIdOverride]="customerIdFromRoute"
        [catalogIdOverride]="catalogIdFromRoute"
        [additionalFilter]="additionalFilterForBrowseComponent"
      ></catalog>
    </div>
  </div>

  <div class="np-detail-right-spacer" [class.right-hidden]="!isBrowseTab"></div>

  <help-column
    class="align-self-stretch {{ systemService.showHelp ? '' : 'd-none' }}"
    style="flex: 1 1;"
  ></help-column>
</fullscreen-page>
